import React from 'react';
import { Icon } from '../../icons';
import './auth.css';

interface AuthLayoutProps {
  title: string;
  subtitle?: React.ReactNode;
  /** Server-side or form-level error, shown above the form. */
  error?: string;
  /** Rendered under the card, e.g. the sign-in / sign-up switch. */
  footer?: React.ReactNode;
  children: React.ReactNode;
}

export function AuthLayout({ title, subtitle, error, footer, children }: AuthLayoutProps) {
  return (
    <main className="auth-screen">
      <div className="auth-card">
        <img src="/logo.png" alt="Overwatch" className="auth-logo" />
        <h1 className="auth-title">{title}</h1>
        {subtitle && <p className="auth-subtitle">{subtitle}</p>}
        {error && <AuthAlert>{error}</AuthAlert>}
        {children}
      </div>
      {footer && <p className="auth-switch">{footer}</p>}
    </main>
  );
}

export function AuthAlert({ tone = 'danger', children }: { tone?: 'danger' | 'warning'; children: React.ReactNode }) {
  return (
    <div className={`auth-alert${tone === 'warning' ? ' auth-alert--warning' : ''}`} role="alert">
      <Icon name="warning" size={14} />
      <span>{children}</span>
    </div>
  );
}
